<template>
    <button type="button" class="cpb" :class="{'is-copied': copied, 'has-text': !!text}"
        :title="copied ? 'Copiado!' : `Copiar ${label}`" @click.stop.prevent="copy">
        <span class="cpb-icon" aria-hidden="true">
            <fa v-if="copied" icon="check" />
            <fa v-else :icon="['far', 'copy']" />
        </span>
        <span v-if="text" class="cpb-text">{{copied ? 'Copiado' : text}}</span>
        <span v-else class="sr-only">Copiar {{label}}</span>
        <!-- Confirmação para leitor de tela sem depender do ícone -->
        <span class="sr-only" aria-live="polite">{{copied ? `${label} copiado` : ''}}</span>
    </button>
</template>

<script>
import { copyText } from '@/utils/helpers/ClipboardHelper'

const FEEDBACK_MS = 1600

/**
 * Botão de copiar com confirmação no próprio botão (o ícone vira um check por
 * um instante), sem alerta flutuante a cada cópia.
 */
export default {
    name: 'CopyButtonCmp',
    props: {
        // O que vai para a área de transferência
        value: {
            type: [String, Number],
            required: true,
        },
        // Nome do que é copiado, para o título e o leitor de tela ("CPF", "endereço"...)
        label: {
            type: String,
            default: '',
        },
        // Texto visível ao lado do ícone (ex.: "Copiar endereço"); sem ele, só o ícone
        text: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            copied: false,
            timer: null,
        }
    },
    methods: {
        async copy() {
            if (!(await copyText(String(this.value)))) {
                return
            }

            this.copied = true
            clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                this.copied = false
            }, FEEDBACK_MS)
        },
    },
    beforeDestroy() {
        clearTimeout(this.timer)
    },
}
</script>

<style lang="scss" scoped>
.cpb {
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-width: 28px;
    height: 28px;
    padding: 0;
    border: 1px solid transparent;
    border-radius: 7px;
    color: var(--text-muted);
    background: transparent;
    font-size: 12px;
    vertical-align: middle;
    cursor: pointer;
    transition: color .15s, background-color .15s, border-color .15s;

    &.has-text {
        padding: 0 10px;
        border-color: var(--border);
        font-weight: 700;
    }

    &:hover,
    &:focus-visible {
        border-color: var(--tint-brand-border);
        color: var(--brand);
        background: var(--tint-brand-bg);
        outline: none;
    }

    &.is-copied {
        border-color: var(--success-border);
        color: var(--success-fg);
        background: var(--success-bg);
    }
}

.cpb-icon {
    display: inline-flex;

    .is-copied & {
        animation: cpb-pop .3s cubic-bezier(.22, 1, .36, 1);
    }
}

@keyframes cpb-pop {
    0% { transform: scale(.4); }
    70% { transform: scale(1.2); }
    100% { transform: scale(1); }
}

@media (prefers-reduced-motion: reduce) {
    .is-copied .cpb-icon {
        animation: none;
    }
}
</style>
